var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMastercardBrandColors = function SvgMastercardBrandColors(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5A00",
    d: "M18.704 11.142h-5.408v9.716h5.408z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F79E1B",
    d: "M26 16a6.176 6.176 0 0 1-9.992 4.858A6.15 6.15 0 0 0 18.36 16a6.2 6.2 0 0 0-2.352-4.858 6.14 6.14 0 0 1 3.81-1.322A6.19 6.19 0 0 1 26 16"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB001B",
    d: "M13.656 16c0-1.974.928-3.726 2.352-4.858A6.176 6.176 0 0 0 6.016 16a6.176 6.176 0 0 0 9.992 4.858A6.17 6.17 0 0 1 13.656 16"
  })));
};
export { SvgMastercardBrandColors as ReactComponent };